window._ = require('lodash');

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

try {
    window.Popper = require('popper.js').default;
    window.$ = window.jQuery = require('jquery');

    require('bootstrap');
} catch (e) {
}

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

window.waypoints = require('waypoints/lib/jquery.waypoints');

/**
 * Next we will register the CSRF Token as a common header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience so we don't have to attach every token manually.
 */

setTimeout(() => {
    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        }
    });

    // let token = document.head.querySelector('meta[name="csrf-token"]');
    //
    // if (token) {
    //     window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
    // } else {
    //     console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
    // }
}, 100);

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo'

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     encrypted: true
// });

let baseUrl = $('base').attr('href');
let baseUrlMain = $('base').attr('data-main');

$.ajaxSetup({
    beforeSend: function (xhr, options) {
        if (!options.url.includes(baseUrlMain)) {
            options.url = baseUrl + options.url;
        }
    },
    headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    }
});

var LANG = require('./lang.json');
var LOCALE = 'ro';

window.trans = function (desc) {
    desc = LOCALE + '.' + desc;
    var obj = LANG;
    var arr = desc.split(".");
    while (arr.length && (obj = obj[arr.shift()])) ;
    return obj || desc.replace(LOCALE + '.', '');
};
